import React, { Component } from "react";
import { MDBRow, MDBCol, MDBContainer, MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter, MDBInput
} from "mdbreact";
import { getFieldListFields, translate } from "../utils/Utils";
import DragDropDoubleList from "../components/DragDropDoubleList";
import "../css/NewTemplateModal.css";
import PropTypes from "prop-types";

class EditTemplateModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templateName: this.props.templateName,
            selectedFields: this.props.selectedFields,
            fieldListFields: getFieldListFields(this.props.selectedFields, this.props.modalID.includes("download-table") ? false : true)
        };
        this.handleDragDrop = this.handleDragDrop.bind(this);
    }

    showSaveButton() {
        const template_name = this.state.templateName;
        if ((this.props.templateNames.includes(template_name) && template_name !== this.props.templateName) || template_name.trim().length === 0) {
            return false;
        } else {
            return true;
        }
    }

    saveTemplate() {
        this.props.saveEditedTemplate(this.state.templateName, this.state.selectedFields);
    }

    closeModal() {
        this.props.closeEditTemplateModal();
    }

    handleDragDrop(result) {
        this.setState({
            selectedFields: result,
            fieldListFields: getFieldListFields(result)
        });
    }

    render() {
        return (
            <MDBModal
                id={this.props.modalID}
                className="edit-template-modal"
                size="lg"
                isOpen
                toggle={() => this.closeModal()}
            >
                <MDBModalHeader 
                    toggle={() => this.closeModal()}
                >
                    {translate("edit_template")}
                </MDBModalHeader>
                <MDBModalBody
                    className="modal-body"
                >
                    <MDBContainer>
                        <MDBRow>
                            <MDBCol>
                                <MDBInput 
                                    label={translate("template_name")}
                                    value={this.state.templateName}
                                    onInput={event => this.setState({
                                        templateName: event.target.value
                                    })}
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <DragDropDoubleList 
                                selectedFields={this.state.selectedFields}
                                fieldListFields={this.state.fieldListFields}
                                handleDragDrop={this.handleDragDrop}
                            />
                        </MDBRow>
                    </MDBContainer>
                </MDBModalBody>
                <MDBModalFooter>
                    {!this.showSaveButton() ? null :
                        <button
                            className="btn btn-sm"
                            onClick={() => this.saveTemplate()}
                        >
                            {translate("save")}
                        </button>
                    }
                    <button
                        className="btn btn-sm"
                        onClick={() => this.closeModal()}
                    >
                        {translate("close")}
                    </button>
                </MDBModalFooter>
            </MDBModal>
        )
    }
}

EditTemplateModal.propTypes = {
    closeNewTemplateModal: PropTypes.func.isRequired,
    templateName: PropTypes.string.isRequired,
    saveEditedTemplate: PropTypes.func.isRequired,
    selectedFields: PropTypes.array.isRequired,
    templateNames: PropTypes.array.isRequired,
    modalID: PropTypes.string.isRequired
};

export default EditTemplateModal;